export { default } from "./updateEmail";
